import { Component, OnInit } from '@angular/core';

/** Login form placeholder — authentication is delegated to Keycloak; this component is kept for route compatibility. */
@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.css']
})

export class LoginFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    console.log('*** LoginFormComponent onInit: ')

  }

}
